import React from "react"
import clsx from "clsx"

import Container from "@ecom/ui/components/Container"
import Button from "@material-ui/core/Button"

import * as styles from "./BottomCta.module.scss"
import { GradientBorder } from "../GradientBorder"
import { RightBlock } from "./RightBlock"
import { HalvaCardImg } from "./img"
import { BottomCtaProps } from "./types"
import { DLClickEventExtended } from "../../helpers/WatcherDL/DLEvents"
import getTextFromNode from "../../helpers/getTextFromNode"
import scrollToPersonalForm from "../../helpers/scrollToPersonalForm"
import { StickerBearImg } from "./img/StickerBearImg"

const DEFAULT_TITLE = (
  <>
    Оформите Халву и получите <br /> <b> месяц подписки в подарок</b>
  </>
)

export const BottomCta = ({
  buttonText = "Оформить карту",
  title = DEFAULT_TITLE,
  variant = "halva",
  orderNum,
  BgImg,
  StickerPay = false,
  newYear = false,
  AB = false,
  urlForButtonRedirect,
  btnCustomColor,
}: BottomCtaProps) => {
  const handleClick = () => {
    DLClickEventExtended({
      name: buttonText,
      eventAction: getTextFromNode(title).slice(0, 30),
      placement: "promo",
    })

    if (urlForButtonRedirect) {
      window.open(urlForButtonRedirect, "_blank")
    } else {
      scrollToPersonalForm()
    }
  }

  return (
    <section
      id="bottomCta"
      className={clsx(styles.section, styles[variant])}
      data-exclude={orderNum}
    >
      <Container className={styles.container}>
        <div className={clsx(styles.wrapper, styles[variant], AB && styles.AbBg)}>
          {AB ? null : <BgImg alt="background image" className={styles.img} />}

          {!StickerPay && (
            <HalvaCardImg
              alt="halvaCard"
              className={clsx(styles.halvaCardImgMobile, styles[variant], AB && styles.ab)}
            />
          )}
          {variant === "stickerMode" && (
            <StickerBearImg alt="sticker" className={styles.stickerBearImgMobile} />
          )}
          <GradientBorder className={clsx(styles.wrap, styles[variant])}>
            <RightBlock variant={variant} StickerPay={StickerPay} newYear={newYear} AB={AB} />
            <p className={clsx(styles.text, styles[variant])}>{title}</p>
            <Button
              className={clsx(styles.btn, btnCustomColor && styles.btnCustomColor, styles[variant])}
              onClick={handleClick}
            >
              {buttonText}
            </Button>
          </GradientBorder>
        </div>
      </Container>
    </section>
  )
}
